import { EPEmployerService } from './../../../../services/EmployerPortalServices/ep-employer.service';

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

@Injectable()
export class PreviousContributionsViewEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private router: Router,
    private service: EPEmployerService) {
  }

  getData$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestAction),
    switchMap((action: any) => this.service.getPreviousContributions(action.page)),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));

}
